// IDI-544 / IDI-547: the two-state "accepted" line shared by quotes and
// change orders. A document was either e-signed or accepted manually — never
// a channel name (phone, email…), never a default "via e-sign", and never the
// raw "e_sign" value.
import { formatDate, formatTime } from '../../utils/formatDate';

// IDI-533: change orders write `acceptedAt`; quotes never do. The e-sign
// path writes `signatureAcknowledgedAt`, Record Decision writes
// `acknowledgedAt`. Same fallback LockedAtAcceptancePill uses in QuoteDetail.
export function acceptedAtOf(doc) {
  return (
    doc?.acceptedAt ||
    doc?.accepted_at ||
    doc?.signatureAcknowledgedAt ||
    doc?.signature_acknowledged_at ||
    doc?.acknowledgedAt ||
    doc?.acknowledged_at
  );
}

export function isESigned(doc) {
  return (
    doc?.decisionChannel === 'e_sign' ||
    doc?.decision_channel === 'e_sign' ||
    !!(doc?.signatureAcknowledgedAt || doc?.signature_acknowledged_at)
  );
}

function signerOf(doc) {
  return doc?.signatureSignerName || doc?.signature_signer_name || '';
}

export function acceptedLine(doc) {
  const at = acceptedAtOf(doc);
  const when = at ? ` on ${formatDate(at)} at ${formatTime(at)}` : '';
  if (isESigned(doc)) {
    const signer = signerOf(doc);
    return `E-signed${signer ? ` by ${signer}` : ''}${when}`;
  }
  return `Accepted manually${when}`;
}
